<style lang="less" scoped>
@import '../../../style/common/variable';
.imgTitleContent{position: relative;width: 700px;height: 170px;display: flex;border-bottom: solid rgb(173, 172, 172);border-width:1px;overflow: hidden;font-family: AlibabaPuHuiTi-Regular;margin-top: 18px;}
.boxWrap {width: 692px;height: 170px;border-width: 1px;margin-top:15px;margin-bottom:0;border-bottom:1px dashed #eee;cursor: pointer;}
.picbox {position: absolute;left: 5px;width: 256px;height: 148px;overflow: hidden;border: 1px solid #eee;}
.picbox img{width: 256px;height: 148px;margin-right: 20px;transition: transform .5s;}
img:hover {transform: scale(1.4,1.4)}
.box{position: absolute;left: 280px;margin: 0px;}
p{margin: 0px;}
.name{width: 520px;font-size: 16px;font-weight: 600;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.name:hover{color: #13569e;}
.content{font-size: 13px;margin-top: 14px;margin-bottom: 24px;margin-right: 12px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;}
.content{height: 48px;line-height: 16px; overflow:hidden;}
.content::after{content: ' ... ';}
.size{font-size: 12px;margin-top: 14px;}
.type{font-size: 12px;margin-top: 5px;}
@media screen and (max-width: @max-screen){
  .imgTitleContent {width: 100% !important;height: auto !important;flex-direction: column;margin-top: 12px;border-bottom-width: 0.5px;}
  .boxWrap {width: 100% !important;height: auto;margin-top: 10px;border-bottom: none;}
  .picbox {position: relative !important;left: 0 !important;width: 100% !important;height: 160px !important;margin-bottom: 8px;border: 0.5px solid #eee;}
  .picbox img {width: 100% !important;height: 100% !important;margin-right: 0;object-fit: cover;transition: none !important;}
  .box {position: relative !important;left: 0 !important;padding: 0 10px;}
  .name {width: 100% !important;font-size: 14px !important;white-space: normal !important;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}
  .content {font-size: 12px !important;margin: 8px 0 !important;height: 40px !important;line-height: 1.4 !important;-webkit-line-clamp: 3;}
  .content::after {content: '';}
  .size, .type {font-size: 11px !important;margin-top: 6px !important;}
  .boxWrap::after {content: "";display: block;height: 1px;background: #eee;margin: 12px 10px;}
  .boxWrap:last-child::after {display: none;}
}
</style>

<!--李旭 2021.8.19
    该组件使用场景：以列表形式纵向展示 公司图片、名称、简介等信息，点击该信息，将整个对象传递给父组件-->
<template>
  <div class="imgTitleContent" @click="handleClick(imgNameIntroduce)">
    <div class="boxWrap">
      <div class="picbox">
        <img :src="imgNameIntroduce.pic" />
      </div>
      <div class="box">
        <p class="name"> {{ imgNameIntroduce.name }} </p>
        <p class="content"> {{ imgNameIntroduce.introduce }} </p>
        <p class="size"> {{ imgNameIntroduce.guimo}}：{{ imgNameIntroduce.size }} </p>
        <p class="type"> {{ imgNameIntroduce.description}}：{{ imgNameIntroduce.type }} </p>
      </div>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: ['imgNameIntroduce'],
  mixins: [filters],
  data()
  {
    return {}
  },
  updated()
  {
    var oList = document.querySelectorAll('.content')
    var alltableArray = Array.prototype.slice.call(oList)
    alltableArray.forEach(function(item)
    {
      var oHeight = item.height
      if ((oHeight / 15) > 2)
        item.className = 'content'
    })
  },
  // 点击图片、标题、内容，将 被点击的整个信息对象 传递给父组件
  methods: {
    handleClick(item)
    {
      this.$emit('handleClick', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/ImgNameIntroduce.vue